import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '../features/auth/AuthContext';
import '../styles/AuthLayout.css';

const AuthLayout = () => {
  const { isAuthenticated, user } = useAuth();

  // Redirect to appropriate home if already authenticated
  if (isAuthenticated) {
    if (user?.user_type === 'admin') {
      return <Navigate to="/admin" replace />;
    }
    return <Navigate to="/internship/projects" replace />;
  }

  return (
    <div className="auth-layout">
      <div className="auth-container">
        <Outlet />
      </div>
    </div>
  );
};

export default AuthLayout;
